var render = function render(){var _vm=this,_c=_vm._self._c;return _c('embed',{staticStyle:{"position":"absolute","width":"100%","height":"100%","border":"none"},attrs:{"src":`https://docs.google.com/viewer?url=${encodeURI(_vm.src)}&embedded=true`}})
}
var staticRenderFns = []

export { render, staticRenderFns }